<template>
  <div>
    <b-row
      v-if="isLoading"
      class="d-flex justify-content-center"
      style="gap: 10px;"
    >
      <b-spinner
        v-for="index in 3"
        :key="index"
        variant="dark"
        type="grow"
        :style="{ animationDelay: `${(index - 0.5)}s` }"
      />
    </b-row>

    <b-row v-if="!isLoading">
      <b-col cols="12">
        <b-list-group-item
          class="d-flex"
          style="gap: 20px;"
        >
          <div>
            <b-card-title>This task is created by : </b-card-title>
            <div class="d-flex">
              <b-avatar
                class="mx-1"
                variant="success"
              />
              <div class="d-flex flex-column">
                <span v-if="detailsData.created_by"> {{ detailsData.created_by.name }}</span>
                <span v-if="detailsData.created_by"> {{ detailsData.created_by.email }}</span>
              </div>
              <div class="d-flex align-items-end pl-3">
                <span>(Added {{ formatDate(detailsData.created_at) }})</span>
              </div>
            </div>
          </div>
        </b-list-group-item>
      </b-col>
    </b-row>

    <b-row v-if="!isLoading">
      <b-col
        cols="7"
        class="min-height-card border-right"
      >
        <div
          class="d-flex justify-content-end my-1"
        >
          <span
            v-if="detailsData.is_late"
            class="badge badge-danger mx-2"
          >Late Task</span>
          <span
            v-if="detailsData.due_date"
            class="badge badge-warning"
          >Due Date: {{ formatDate(detailsData.due_date) }}</span>
        </div>
        <div class="mt-2">
          <b-card-title>
            <input type="radio">
            {{ detailsData.issue }}
          </b-card-title>
          <b-card-title>
            <p class="text-bold text-primary">
              <feather-icon
                icon="AlignLeftIcon"
                size="15"
              />
              Description
            </p>
            <b-textarea
              v-model=" detailsData.description"
              placeholder="Fixed height textarea"
              rows="4"
              disabled
            />
            <!-- disabled="false" -->
          </b-card-title>
          <b-card-title class="d-flex">
            <p class="text-bold text-primary">
              <feather-icon
                icon="ZapIcon"
                size="15"
              />
              Required Action :
            </p>
            <span class="ml-1">{{ detailsData.required_action }}</span>
            <!-- disabled="false" -->
          </b-card-title>
          <b-card-title>
            <p class="text-bold text-primary">
              <feather-icon
                icon="PaperclipIcon"
                size="15"
              />
              Attachments
            </p>
            <div v-if="Array.isArray(detailsData.attachments) && detailsData.attachments.length">
              <div
                v-for="file in detailsData.attachments"
                :key="file.id"
              >
                <b-img
                  v-if="isImage(file.file_name)"
                  width="75"
                  height="75"
                  class="m-1"
                  target="_blank"
                  rounded
                  alt="Rounded image"
                  :src="file.url"
                />
                <feather-icon
                  v-else
                  icon="FileTextIcon"
                  color="#424242"
                  size="60"
                />
                <a
                  :href="file.url"
                  target="_blank"
                  class="text-dark"
                >
                  {{ file.file_name }}
                </a>
              </div>
            </div>
            <div v-else>
              No Attachments Found
            </div>
          </b-card-title>
        </div>
      </b-col>
      <b-col cols="5">

        <div>
          <b-col
            cols="12"
            style="border-bottom: 1px solid #d8d6de;"
          >
            <h4 style="padding: 8px 0px;">
              comments ({{ Array.isArray(detailsData.comments) ? detailsData.comments.length : 0 }})
            </h4>
          </b-col>
          <b-col
            cols="12"
            style="border-bottom: 1px solid #d8d6de;"
          >

            <ul class="list-unstyled mt-2">
              <b-media tag="li">
                <h6 class="px-2">
                  <feather-icon
                    class="cursor-pointer"
                    icon="MessageSquareIcon"
                    size="20"
                  /> Add Your Comment
                </h6>
                <b-col cols="12">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text>
                        <feather-icon
                          icon="PaperclipIcon"
                          size="18"
                          class="cursor-pointer"
                          @click="triggerFileUpload"
                        />
                        <input
                          ref="fileInput"
                          type="file"
                          multiple
                          style="display: none;"
                          @change="handleFileUpload"
                        ></b-input-group-text>
                    </template>
                    <b-form-input v-model="newComment" />
                  </b-input-group>

                </b-col>
                <!-- File upload icon and hidden input -->
                <b-row class="w-100">
                  <b-col
                    cols="11"
                    class="d-flex pl-3"
                  >
                    <div
                      v-if="selectedFiles.length"
                      class="mt-2 w-100"
                    >
                      <h6>Selected Files:</h6>
                      <div class="d-flex flex-wrap">
                        <span
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                          class="pb-1"
                        >
                          {{ file.name.split(' ').slice(0, 1).join(' ') + '...' }}

                          <feather-icon
                            class="cursor-pointer"
                            icon="TrashIcon"
                            size="15"
                            color="red"
                            @click="removeFile(index)"
                          />
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col />
                </b-row>
              </b-media>

            </ul>
            <div class="d-flex justify-content-end mb-1">
              <b-button
                v-if="!loadingBtn"
                variant="primary"
                @click="addComment"
              >
                Add commnet
              </b-button>
              <b-button
                v-if="loadingBtn"
                variant="primary"
                disabled
                class="mr-1"
              >
                <b-spinner variant="grow" />

              </b-button>

            </div>
          </b-col>

          <b-row
            class="control-all-comments"
          >

            <b-col
              v-for="(com, index) in (Array.isArray(detailsData.comments) ? detailsData.comments.slice().reverse() : [])"
              :key="index"
              cols="12"
              class="d-flex"
            >
              <div
                style="width: fit-content;"
                class="px-1 mt-1"
              >
                <b-avatar
                  variant="info"
                  style="color: black;"
                />
              </div>
              <div>
                <span style="font-size: small; font-weight: bold;">
                  {{ com.user.name }}
                </span>
                <span style="font-size: small; white-space: normal; word-break: break-word;"> {{ com.comment }}</span>
                <span
                  style="font-size: small; text-decoration: underline; display: block;"
                  class="text-primary"
                >
                  {{ formatDate(com.created_at) }}
                </span>
              </div>
            </b-col>
          </b-row>

          <!-- <p class="mb-0 pt-1 d-flex flex-wrap justify-content-start align-items-center">
                    <span
                      v-for="attachment in com.attachments"
                      :key="attachment.id"
                      class="mr-1"
                      style="border: 1px solid #d8d6de; padding: 4px 10px "
                    >
                      <a
                        :href="`${attachment.url}`"
                        target="_blank"
                        class="text-dark"
                      >
                        <feather-icon
                          icon="FileIcon"
                          size="15"
                        />
                        {{ attachment.file_name }}
                      </a>
                      <feather-icon
                        icon="TrashIcon"
                        size="15"
                        color="red"
                        class="ml-2 cursor-pointer"

                        @click="deleteAttachment(attachment.id , com.id )"
                      />
                    </span>
                  </p> -->

        </div>

      </b-col>

    </b-row>

    <b-row v-if="!isLoading">
      <b-col cols="12">
        <div>
          <div class="d-flex align-items-center flex-wrap">
            <span class="font-weight-bold text-xl">This task is assigned to : </span>
            <div
              v-for="assign in detailsData.assigned"
              :key="assign.id"
            >
              <b-avatar
                class="mx-1"
                variant="primary"
                :title="assign.user.email"
              />
              <span v-if="detailsData.created_by"> {{ assign.user.name }}</span>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>
<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    modalId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      detailsData: {},
      isLoading: false,
      fileWidths: [],
      selected: '',
      newComment: '',
      selectedFiles: [],
      loadingBtn: false,
    }
  },
  mounted() {
    this.getTaksById()
  },
  methods: {
    removeFile(index) {
      this.selectedFiles.splice(index, 1) // Remove file from selected files array
    },
    triggerFileUpload() {
      this.$refs.fileInput.click() // Trigger file input on icon click
    },
    handleFileUpload(event) {
      this.selectedFiles = Array.from(event.target.files) // Store selected files
    },
    isImage(fileName) {
      return /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(fileName)
    },
    getTaksById() {
      this.isLoading = true
      axios.get(`https://gulftic-system.fci.group/api/task/${this.modalId}`).then(response => {
        this.detailsData = decryptData(response.data.payload).data
        // console.log(this.detailsData)
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || 'Have an error to get task details',
            icon: 'BellIcon',
            variant: 'error',
          },
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    addComment() {
      if (!this.newComment.trim() && this.selectedFiles.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please enter a comment or attach a file.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      this.loadingBtn = true
      const formData = new FormData()
      formData.append('comment', this.newComment)
      this.selectedFiles.forEach((file, index) => {
        formData.append(`attachments[${index}]`, file)
      })

      axios.post(`https://gulftic-system.fci.group/api/task/${this.modalId}/comment`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          if (res.status === 200) {
            this.newComment = ''
            this.selectedFiles = []
            this.getTaksById()
          }
        })
        .catch(error => {
          const payload = decryptData(error?.response?.data?.payload)?.message
          const firstArrayKey = Object.keys(payload || {}).find(key => Array.isArray(payload[key]))
          const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'

          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorMessage,
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        })
        .finally(() => {
          this.loadingBtn = false
        })
    },
    formatDate(dateString) {
      if (!dateString) return ''

      const date = new Date(dateString)

      const day = date.getDate()
      const month = date.toLocaleString('en-US', { month: 'short' })
      const year = date.getFullYear()

      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${day} ${month} ${year} ${hours}:${minutes}`
    },

  },
}
</script>

 <style lang="scss">
 @import '@core/scss/vue/libs/vue-select.scss';
 .min-height-card{
  height: 65vh;
  overflow-y: auto;
}
  .control-all-comments{
    max-height: 38vh;
    overflow-y: scroll;
  }
  .control-all-comments::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.control-all-comments::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.control-all-comments::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.control-all-comments::-webkit-scrollbar-thumb:hover {
  background: #555;
}
  </style>
